import React from "react";
import styles from "./SupplierTable.module.css";

const SupplierTable = ({ items, loading, onEdit, onDelete }) => {
  if (loading) return <div className={styles.state}>جارِ التحميل...</div>;
  if (!items.length) return <div className={styles.state}>لا توجد معاملات لعرضها</div>;

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>المورد</th>
            <th>الصنف</th>
            <th>الكمية</th>
            <th>سعر الوحدة</th>
            <th>الإجمالي</th>
            <th>المدفوع</th>
            <th>المتبقي</th>
            <th>التاريخ</th>
            <th>إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className={styles.strong}>{item.supplierName}</td>
              <td>{item.itemName}</td>
              <td>{item.quantity}</td>
              <td>{item.unitPrice.toLocaleString("ar-EG")}</td>
              <td>{item.totalAmount.toLocaleString("ar-EG")}</td>
              <td className={styles.paid}>{item.paidAmount.toLocaleString("ar-EG")}</td>
              <td className={item.remainingAmount > 0 ? styles.remaining : styles.settled}>
                {item.remainingAmount.toLocaleString("ar-EG")}
              </td>
              <td>{new Date(item.transactionDate).toLocaleDateString("ar-EG")}</td>
              <td>
                <div className={styles.rowActions}>
                  <button className={styles.editBtn} onClick={() => onEdit(item)}>تعديل</button>
                  <button className={styles.deleteBtn} onClick={() => onDelete(item)}>حذف</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupplierTable;